import React, { useContext } from "react";
import { observer } from "mobx-react-lite";

import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";
import { OfferStoreContext } from "@gp/components";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { EventInsightsContent } from "./EventInsightsContent";

export const EventInsightsSection = observer(function EventInsightsSection() {
	const store = useContext(OfferStoreContext) as
		| EventViewStore
		| AdditionalOfferViewStore;

	if (store?.displayStatisticsGroup === StatisticsGroups.EventInsights) {
		return <EventInsightsContent store={store.sportStatisticsStore} />;
	}

	return null;
});
